import { gql, TypedDocumentNode } from "@apollo/client";

import { employeeFragment } from "./newEmployee";
import { newReferenceFragment } from "./references";
import {
  GetEmployeeCvQuery,
  GetEmployeeCvQueryVariables,
  GetSingleReferenceQuery,
  GetSingleReferenceQueryVariables,
} from "generated/graphql";

// QUERIES

export const EMPLOYEE_WORD_QUERY: TypedDocumentNode<
  GetEmployeeCvQuery,
  GetEmployeeCvQueryVariables
> = gql`
  ${employeeFragment}
  ${newReferenceFragment}
  query getEmployeeCv($id: ID!) {
    employee(id: $id) {
      ...Employee_fields
      largeProfilePicture: profilePicture(size: 504)
      colorProfilePicture(size: 504)
      references {
        ...NewReference_fields
        project {
          id
          name {
            id
            de
            en
            fr
            it
          }
          client {
            id
            name
            country
          }
          country
          clientHidden
        }
        parentReference {
          ...NewReference_fields
          parentReference {
            ...NewReference_fields
          }
        }
      }
    }
  }
`;

export const SINGLE_REFERENCE_WORD_QUERY: TypedDocumentNode<
  GetSingleReferenceQuery,
  GetSingleReferenceQueryVariables
> = gql`
  ${newReferenceFragment}
  query getSingleReference($id: ID!) {
    reference(id: $id) {
      ...NewReference_fields
      project {
        id
        name {
          id
          de
          en
          fr
          it
        }
        client {
          id
          name
          country
        }
        clientHidden
        country
      }
      parentReference {
        ...NewReference_fields
        parentReference {
          ...NewReference_fields
        }
      }
    }
  }
`;
